import { Component } from '@angular/core'

@Component({
  template: '<ftr-not-found></ftr-not-found>',
})
export class NotFoundPage {}
